/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .constant('ElementsThatKeepTheSelectedState', [
        '#actions p *',
        '.data-table tbody tr *',
        '.multi-select-summary',
        '.modal *'
    ])
    .directive('accMultiSelect', ['$document', '$window', '$modalStack', 'MobileTools', 'ElementsThatKeepTheSelectedState',
        function($document, $window, $modalStack, MobileTools, ElementsThatKeepTheSelectedState) {
        var ESCAPE_REMOVES_SELECTION = true,
            CTRL_A_SELECTS_ALL = true,
            EVENT_KEY_ESC = 27,
            EVENT_KEY_A = 65;

        return {
            scope: true,

            link: function($scope){
                var selectionIndexOrder = [],
                    selectedNodes = [];

                $scope.isTouchDevice = MobileTools.isTouchDevice;

                $scope.toggleSelect = function(node, isMultiSelecting, $event) {
                    _preventElementSelection($event);

                    // Avoid select toggling in case of
                    // - when user trying to select node via mousedragging over the node
                    if (_isUserSelectedText()) {
                        return;
                    }
                    // - or when user try deselect currently renaming node
                    if (_isUserRenamingNode(node.uuid)) {
                        return;
                    }

                    var clickedIndex = $scope.table.entries.indexOf(node);

                    if ($event && ($event.shiftKey || isCtrlKeydown($event))) {
                        isMultiSelecting = true;
                    }
                    if (!isMultiSelecting && ($scope.hasMultiSelectedNodes() || !$scope.isNodeSelected(node))) {
                        $scope.resetMultiSelect();
                    }

                    if ($event && $event.shiftKey) {
                        _processShiftSelection(clickedIndex);
                    } else {
                        _processNormalSelection(node, clickedIndex);
                    }
                };

                $scope.getSelectedNodes = function(){
                    return selectedNodes;
                };

                $scope.removeSelectedNodes = function() {
                    selectedNodes.forEach(function(node) {
                        if (node.hasOwnProperty('renaming')) {
                            delete node.renaming;
                        }
                    });
                    selectedNodes = [];
                };

                $scope.hasSelectedNodes = function() {
                    return selectedNodes.length > 0;
                };

                $scope.hasMultiSelectedNodes = function() {
                    return selectedNodes.length > 1;
                };

                $scope.hasSelectedNodesCount = function(count) {
                    return selectedNodes.length == count;
                };

                $scope.getSelectedNode = function() {
                    return selectedNodes[0];
                };

                $scope.isNodeSelected = function(node) {
                    return $.inArray(node, selectedNodes) > -1;
                };

                $scope.resetSelectionOrder = function(){
                    selectionIndexOrder = [];
                };

                $scope.resetMultiSelect = function(){
                    $scope.removeSelectedNodes();
                    $scope.resetSelectionOrder();
                };

                function _processShiftSelection(clickedIndex) {
                    var border = _lastSelected() || 0;

                    $scope.removeSelectedNodes();
                    for (var i = Math.min(border, clickedIndex); i <= Math.max(border, clickedIndex); i++) {
                        _addSelectedNode($scope.table.entries[i]);
                    }
                }

                function _processNormalSelection(node, clickedIndex) {
                    _addSelectionIndex(clickedIndex);
                    if ($scope.isNodeSelected(node)) {
                        _removeSelectedNode(node);
                    } else {
                        _addSelectedNode(node);
                    }
                }

                function _addSelectionIndex(index) {
                    selectionIndexOrder.push(index);
                }

                function _removeSelectedNode(node) {
                    selectedNodes.splice(selectedNodes.indexOf(node), 1);
                    if (node.hasOwnProperty('renaming')) {
                        delete node.renaming;
                    }
                }

                function _addSelectedNode(node){
                    selectedNodes.push(node);
                }


                function _lastSelected() {
                    return selectionIndexOrder[selectionIndexOrder.length - 1];
                }

                function _preventElementSelection(event) {
                  var selection = $window.getSelection();

                  if (
                    selection !== null &&
                    selection.type !== 'None' &&
                    selection.focusNode !== null &&
                    selection.focusNode.nodeType !== Node.TEXT_NODE ||
                    isCtrlKeydown(event)
                  ) {
                    selection.removeAllRanges();
                  }
                }

                function _isUserSelectedText() {
                    return $window.getSelection().toString().length !== 0;
                }

                function _isUserRenamingNode(nodeUUID) {
                    return $scope.getSelectedNodes().filter(function(node) {
                        return node.renaming && (!nodeUUID || nodeUUID === node.uuid);
                    }).length > 0;
                }

                function handleEscapeKeydown($event) {
                    if (ESCAPE_REMOVES_SELECTION && !$modalStack.getTop()) {
                        $scope.resetMultiSelect();
                        $scope.$apply();
                    }
                }

                function handleCtrlAKeydown($event) {
                    if (CTRL_A_SELECTS_ALL && !$modalStack.getTop()) {
                        $scope.resetMultiSelect();
                        $scope.toggleSelect($scope.table.entries[$scope.table.entries.length - 1], false, {shiftKey: true});
                        $scope.$apply();
                    }
                }

                function handleBodyClick($event) {
                    var clickedElement = $($event.target);

                    // [ASRV-8661] Fixing bug in Chrome browser.
                    // We'll avoid deselecting nodes when user is renaming node
                    // or when it selecting any text on the page
                    if (_isUserRenamingNode() || _isUserSelectedText()) {
                        return;
                    }

                    for (var i in ElementsThatKeepTheSelectedState) {
                        if (clickedElement.is(ElementsThatKeepTheSelectedState[i])) return;
                    }
                    $scope.resetMultiSelect();
                    $scope.$apply();
                }

                function handleShiftClick($event) {
                    $event.preventDefault();
                }

                function isEscapeKeydown($event) {
                    return $event.which == EVENT_KEY_ESC;
                }

                function isCtrlAKeydown($event) {
                    return $event.which == EVENT_KEY_A && isCtrlKeydown($event);
                }

                function isCtrlKeydown($event) {
                    return $event != null && ($event.ctrlKey ||  $event.metaKey); // metaKey is the Mac's ctrlKey
                }

                function isShiftKeydown($event) {
                    return $event.shiftKey;
                }

                $document.off('keydown').on('keydown', function($event){
                    if (isEscapeKeydown($event)) {
                        handleEscapeKeydown($event);
                    }
                    if (isCtrlAKeydown($event)) {
                        handleCtrlAKeydown($event);
                        $event.preventDefault();
                    }
                });

                $document.off('mousedown').on('mousedown', function($event) {
                    if (isShiftKeydown($event)) {
                        handleShiftClick($event);
                    }
                });

                $document.off('click', 'body').on('click', 'body', function($event){
                    handleBodyClick($event);
                });

                $document.off('click', '.data-table td.name a').on('click', '.data-table td.name a', function() {
                    $scope.resetMultiSelect();
                    $scope.$apply();
                });

                $document.off('reload.dataTable').on('reload.dataTable', function(){ // here because of users and devices still trigger it
                    $scope.resetMultiSelect();
                    $scope.$apply();
                });

                $scope.$on('reload.dataTable', function() {
                    $scope.resetMultiSelect();
                });
            }
        }
    }]);
